module.exports = __webpack_public_path__ + "static/media/0137AE6B-FBBC-48CF-82BB-85574FB36289.edeac43e.jpeg";